<section class="k-d-grid k-gap-y-xl">
    <kendo-buttongroup selection="single">
        <button kendoButton [toggleable]="true" fillMode="outline" themeColor="dark" [selected]="isScheduledTab"
            (click)="selectTab('scheduled')">Scheduled
            @if(encounterDetail?.participantsCount){
            <span>({{scheduledParticipantDetails?.length}})</span>
            }
        </button>
        <button kendoButton [toggleable]="true" fillMode="outline" themeColor="dark" [disabled]="!canShowActualTab"
            [selected]="!isScheduledTab && canShowActualTab" (click)="selectTab('actual')">Actual
            @if(encounterDetail?.actualParticipantCount){
            <span>({{actualParticipantDetails?.length}})</span>
            }
        </button>
    </kendo-buttongroup>
    @for (item of participants; track trackByStudentId(item)) {
    <div>
        <p class="!k-font-semibold !k-m-0">{{ item?.studentName }}</p>
        <p class="!k-m-0 secondary-color">
            <span>ID:</span> <span>{{ item?.studentId }}</span> |
            <span>Phys Loc:</span> <span>{{ item?.physLoc }}</span> |
            <span>Grade:</span> <span>{{ item?.grade }}</span> |
            <span>DOB:</span>
            <span>{{ item?.dob | date:'MM/dd/yyyy' }}</span>
        </p>
        <p class="!k-m-0 secondary-color">
            {{ encounterDetail?.mandateDescription }}
        </p>
    </div>
    }

</section>